import React from 'react';
import cn from 'classnames';
import Wrapper from '../Wrapper/Wrapper';
import styles from './InfoRow.module.scss';
import { Tooltip } from 'antd';

const lightTextStyles = [styles.text, styles.light];

const InfoRow = ({
  item,
  renderBadge,
  listItem = false,
  iconPos = 'right',
  onRowClick,
}) => {
  const hasClickHandler = typeof onRowClick === 'function';

  return (
    <Wrapper
      el={listItem ? 'li' : 'div'}
      className={cn(styles.root, { [styles.hovered]: hasClickHandler })}
      onClick={hasClickHandler ? () => onRowClick(item) : undefined}
    >
      <div className={styles.container}>
        <div
          className={cn(styles.contentWrapper, {
            [styles.left]: iconPos === 'right',
            [styles.right]: iconPos !== 'right',
          })}
        >
          <p className={cn(lightTextStyles)}>{item.date}</p>
          <p className={cn(lightTextStyles)}>{item.time}</p>
        </div>
        <div
          className={cn(styles.contentWrapper, {
            [styles.order]: iconPos !== 'right',
            [styles.right]: iconPos === 'right',
            [styles.left]: iconPos !== 'right',
          })}
        >
          {item.cityName && (
            <p
              className={cn(lightTextStyles, {
                [styles.textAlignRight]: iconPos === 'right',
              })}
            >
              {item.cityName}
            </p>
          )}
          {item.serviceCompany && (
            <p
              className={cn(lightTextStyles, {
                [styles.textAlignRight]: iconPos === 'right',
              })}
            >
              {item.serviceCompany}
            </p>
          )}
          <p className={cn(styles.text)}>{item.phone}</p>
          {item.master && (
            <p className={cn(styles.text)}>Сотрудник: {item.master}</p>
          )}
          {item.client && (
            <p className={cn(styles.text)}>Собственник: {item.client}</p>
          )}
        </div>
      </div>
      {item.waitSecond && (
        <p className={cn(styles.text, styles.accent)}>{item.waitSecond}</p>
      )}
      {item.countNotAnswer && (
        <Tooltip
          title="Кол-во пропущенных звонков"
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          <p className={cn(styles.text, styles.accent)}>
            {item.countNotAnswer}
          </p>
        </Tooltip>
      )}
      {typeof renderBadge === 'function' &&
        renderBadge({
          className: cn(styles.icon, {
            [styles.order]: iconPos !== 'right',
          }),
        })}
    </Wrapper>
  );
};

export default InfoRow;
